export enum OrderStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SENT_TO_TEAM = 'SENT_TO_TEAM',
  SENT_TO_CLUB_ADMIN = 'SENT_TO_CLUB_ADMIN',
  SENT_TO_SALES_REP = 'SENT_TO_SALES_REP',
  CONFIRMED_BY_SALES_REP = 'CONFIRMED_BY_SALES_REP',
}
